import { useState, useEffect, useMemo } from "react";

// Components
import {
  Header,
  Body,
  Footer,
  Button,
  WeekDayStrip,
  SlotPicker
} from "../../../components/UI";
import { Heading2, Label } from "../../../components/typography";

// Icons
import { Close } from "../../../SVGS";

// Builders
import * as buttonDesignType from "../../../builders/buttonDesign.types";

// Utils
import { getUtcDateObject } from "../../../utils/timeStampToDate";

// Styles
import { BookedForFormStyles } from "./bookedFor.styles";

const stripToDate = date => {
  if (!date) return null;
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

const BookedForForm = ({
  initialDateValue,
  closeModal,
  updateBookigDate,
  serviceTypeId,
  serviceId
}) => {
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);

  useEffect(() => {
    if (initialDateValue) {
      const initial = getUtcDateObject(initialDateValue);
      setSelectedDay(stripToDate(initial));
      setSelectedSlot(initial);
    }
  }, [initialDateValue]);

  const handleDayChange = day => {
    setSelectedDay(stripToDate(day));
    setSelectedSlot(null);
  };

  const canSave = useMemo(() => !!selectedSlot, [selectedSlot]);

  return (
    <BookedForFormStyles>
      <Header className="header">
        <Heading2 className="headerTitle">
          Change booking date and time
        </Heading2>
        <Close onClick={closeModal} />
      </Header>
      <Body className="formBody">
        <div className="weekSection">
          <Label>Date</Label>
          <WeekDayStrip value={selectedDay} onChange={handleDayChange} />
        </div>
        <div className="slotSection">
          <Label>Time slot</Label>
          <SlotPicker
            serviceTypeId={serviceTypeId}
            excludeServiceId={serviceId}
            selectedDate={selectedDay}
            selectedTime={selectedSlot}
            onSelect={date => setSelectedSlot(date)}
          />
        </div>
      </Body>
      <Footer className="footer">
        <Button
          className="saveButton"
          disabled={!canSave}
          onClick={() => updateBookigDate(selectedSlot)}
          buttonDesignType={buttonDesignType.PRIMARY}
        >
          Save Changes
        </Button>
      </Footer>
    </BookedForFormStyles>
  );
};

export default BookedForForm;
